import { create } from "zustand";
import { persist } from "zustand/middleware";

const useUserStore = create(
    persist(
        (set) => ({
            userInfo: null,
            homeBrand: null,
            deviceRegistrationId: null,
            notificationUnreadCount: 0,
            reservationUnreadCount: 0,
            communityUnreadCount: 0,
            setUserInfo: (info) => set({ userInfo: info }),
            setHomeBrand: (brand) => set({ homeBrand: brand }),
            clearUserInfo: () => set({ userInfo: null, homeBrand: null, notificationUnreadCount: 0 }),
            setDeviceRegistrationId: (id) => set({ deviceRegistrationId: id }),
            setReservationUnreadCount: (count) =>
                set((state) => ({
                    reservationUnreadCount: count,
                    notificationUnreadCount: count + state.communityUnreadCount,
                })),
            setCommunityUnreadCount: (count) =>
                set((state) => ({
                    communityUnreadCount: count,
                    notificationUnreadCount: state.reservationUnreadCount + count,
                })),
            setNotificationUnreadCount: (count) => set({ notificationUnreadCount: count }),
        }),
        { name: "userInfoStorage" } //localstorage key
    )
);

export default useUserStore;
